import script from "./EditUserDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditUserDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditUserDetailsModal.vue?vue&type=style&index=0&id=72d931ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72d931ba"]])

export default __exports__